// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchForm_search__4a6X2","searchInput":"SearchForm_searchInput__SiO15"};